import shopifyGenericDefaults from '../shopify-generic/config.js';

const wheelsFields = ['wheel_tire_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'wheel_tire_diameter'];
const ignoreFields = [...new Set([...wheelsFields, ...tiresFields])];

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    isVehicleSelectionIsolated: true,
    categorySelectionPageRedirect: true,
    isAutoRedirectDisabled: true,
  },
  extra: {
    ...shopifyGenericDefaults.SearchRequestDefaults.extra,
    doNotHideWheelsTiresFacets: window.location.pathname === '/',
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'FacetBarWheels',
          'FacetBarTires',
          'Facets',
          'FilterChips',
          'WheelPanel_tab',
          'TirePanel_tab',
        ].includes(w.name),
    ),
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
      initCollapsed: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      useAutoSyncVisualizer: true,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
      minFacetCount: 2,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: '#cm-wheel-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
      isAutoRedirectDisabled: true,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: '#cm-tire-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: tiresFields,
      isAutoRedirectDisabled: true,
    },
  ],
};
